import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Zap, Sparkles } from 'lucide-react';
import type { PageContext } from '@/lib/page-context';

const PAGE_LABEL_KEYS: Record<string, string> = {
  hub: 'components.contextBadge.pageLabels.hub',
  hub_store: 'components.contextBadge.pageLabels.hubStore',
  hub_settings: 'components.contextBadge.pageLabels.hubSettings',
  hub_article: 'components.contextBadge.pageLabels.article',
  feed: 'components.contextBadge.pageLabels.feed',
  library_saved: 'components.contextBadge.pageLabels.library',
  library_likes: 'components.contextBadge.pageLabels.likes',
  library_tags: 'components.contextBadge.pageLabels.tags',
  library_products: 'components.contextBadge.pageLabels.products',
  scoops_list: 'components.contextBadge.pageLabels.myHubs',
  messages: 'components.contextBadge.pageLabels.messages',
  profile: 'components.contextBadge.pageLabels.profile',
  user_profile: 'components.contextBadge.pageLabels.userProfile',
  settings: 'components.contextBadge.pageLabels.settings',
  workspace: 'components.contextBadge.pageLabels.workspace',
  rooms: 'components.contextBadge.pageLabels.rooms',
  credits: 'components.contextBadge.pageLabels.credits',
  friends: 'components.contextBadge.pageLabels.friends',
  reading_list: 'components.contextBadge.pageLabels.readingList',
  my_posts: 'components.contextBadge.pageLabels.myPosts',
  watch_party: 'components.contextBadge.pageLabels.watchParty',
};

interface Props {
  context: PageContext | null;
  isPro?: boolean;
}

export default function ContextBadge({ context, isPro }: Props) {
  const { t } = useTranslation();
  const label = context
    ? context.hubName || (PAGE_LABEL_KEYS[context.pageType] ? t(PAGE_LABEL_KEYS[context.pageType]) : context.pageType)
    : null;

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 mx-4 mt-2">
      {label && (
        <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-white/3 border border-white/6">
          <MapPin size={10} className="text-iris-400 shrink-0" />
          <span className="text-[10px] text-[#a0a0b0] truncate">{label}</span>
        </div>
      )}
      <div className={`flex items-center gap-1 px-2 py-1 rounded-md border ${
        isPro
          ? 'bg-iris-500/10 border-iris-500/20'
          : 'bg-white/3 border-white/6'
      }`}>
        {isPro ? (
          <Sparkles size={10} className="text-iris-400" />
        ) : (
          <Zap size={10} className="text-[#9a9aac]" />
        )}
        <span className={`text-[10px] ${isPro ? 'text-iris-400' : 'text-[#9a9aac]'}`}>
          {isPro ? t('components.contextBadge.proAi') : t('components.contextBadge.basicAi')}
        </span>
      </div>
    </div>
  );
}
